module.exports = __webpack_public_path__ + "img/search-header-nav-below-mitsu.a4c89468.png";